import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import MailOutlinedSvg from "@ant-design/icons-svg/es/asn/MailOutlined";
import AntdIcon from "../components/AntdIcon";
var MailOutlined = function MailOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MailOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  MailOutlined.displayName = 'MailOutlined';
}
export default /*#__PURE__*/React.forwardRef(MailOutlined);